import { ApiRegion, parseApiRegion } from '@/config';

/** `invalid` is never treated as Canada: an MPQ id must not open against the wrong region. */
export type QueueItemRegion = ApiRegion | 'invalid';

export const queueItemPath = (
  id: number | string,
  region: ApiRegion,
  params: Record<string, string | undefined> = {},
): string => {
  const search = new URLSearchParams();
  if (region !== ApiRegion.CA) {
    search.set('region', region);
  }
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      search.set(key, value);
    }
  });
  const qs = search.toString();
  return `/queue-item/${id}${qs ? `?${qs}` : ''}`;
};

/** A missing `region` is Canada. Anything we do not recognize is `invalid`. */
export const parseQueueItemRegion = (searchParams: URLSearchParams): QueueItemRegion => {
  const values = searchParams.getAll('region');
  if (values.length === 0) {
    return ApiRegion.CA;
  }
  if (values.length > 1) {
    return 'invalid';
  }
  return parseApiRegion(values[0].trim().toLowerCase()) ?? 'invalid';
};

const QA_SESSION_PATH = /^\/qa\/session\/[^/]+\/queue\/[^/]+/;

/** QA sessions stay Canada-only (FOOD-1174 ruling), so a US region there is invalid. */
export const resolveQueueItemRegion = (searchParams: URLSearchParams, pathname: string): QueueItemRegion => {
  const region = parseQueueItemRegion(searchParams);
  if (region !== ApiRegion.CA && QA_SESSION_PATH.test(pathname)) {
    return 'invalid';
  }
  return region;
};

/** List pages show Canada for an unknown region: they list, they never open an id. */
export const listRegionFromSearch = (searchParams: URLSearchParams): ApiRegion => {
  const region = parseQueueItemRegion(searchParams);
  return region === 'invalid' ? ApiRegion.CA : region;
};
